/**
 * @file: cube注册
 * @author: xiaolong.huang@dmall.com
 */

import registerSketchpad from './sketchpad/index';
import registerShelf from './shelf/index';
import registerLayer from './layer/index';
import registerGoods from './goods/index';
import registerDishrack from './dishrack/index';
import registerBeam from './beam/index';
import registerRoof from './roof/index';
import registerFreezer from './freezer/index';
import registerCabinet from './cabinet/index';

interface RegisterParams {
    callByTest: boolean
}

/**
 * cube注册
 *
 * 已测试覆盖 √
 * 测试用例: test/cubeRegister/register.ts
 */
function register(params?: RegisterParams):void {
    // 注册画布cube
    registerSketchpad(params);

    // 注册立式货架cube
    registerShelf(params);

    // 注册普通层板cube
    registerLayer(params);

    // 注册碗碟架cube
    registerDishrack(params);

    // 注册商品cube, 包含隔板和文本框(历史问题)
    registerGoods(params);

    // 注册横杆cube
    registerBeam(params);

    // 注册顶板cube
    registerRoof(params);

    // 注册卧柜cube
    registerFreezer(params);

    // 注册cabinet
    registerCabinet(params);
}

export default register;
